export const cultureToAlpha2 = (culture: string): string => {
  return culture.split('-')[0];
}